var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"menu"},[_c('ul',{staticClass:"menu-list"},_vm._l((_vm.menuList),function(child,index){return _c('base-menu-item',{key:index,attrs:{"menuItem":child}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }